<template>
    <div class="about">
        <heading title="About" tag="site-about-title"/>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'SiteAbout',
    data () {
        return {}
    },
    methods: {}
})
</script>
